import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../editable-cell'

interface SellingPriceProps {}

const SellingPrice: FC<SellingPriceProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'sellingPrice'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default SellingPrice
